export default {
    // 中
    zhCN: {
        name: '名称',
        sort: '排序',
        parent_directory: '上级目录',
        new_directory: '新建目录',
        edit_directory: '编辑目录',
        directory: '文档目录',
        primary_directory: '一级目录',
        secondary_directory: '二级目录',
        document_title: '文档标题',
        vehicle_platform: '车型平台',
        status: '状态',
        create_time: '创建时间',
        model: '车型',
        attachment_name: '附件名称',
        document_information: '文档信息',
        document_tag: '文档标签',
        operation_record: '操作记录',
        operating_time: '操作时间',
        operator: '操作人',
        publishing_department: '发布部门',
        publisher: '发布人',
        person_in_charge: '负责人',
        remarks: '备注',
        publish_objects: '发布对象',
        publish_mode: '发布模式',
        whether_the_document_is_downloadable: '文档是否可下载',
        release_status: '发布状态',
        case_label: '案例标签',
        left_frame: '左驾',
        right_frame: '右驾',
        cab_Position: '驾驶室位置',
        release_time: '发布时间',
        releases: '版本',
        regional_releases: '区域版本',
        pending_approval: '待审批',
        import_date_list: '导入日期清单',
        holiday_name: '节假日名称',
        date: '日期',
        country: '所属国家',
        application_date: '申请日期',
        approver: '审批人',
        withdraw_approval: '撤回审批',
        national_holiday_application: '国家节假日申请',
        submit_for_approval: '提交审批',
        holiday_date: '节假日日期',
        holiday_description: '节假日说明',
    },
    // 英
    enUS: {
        name: 'directory name',
        sort: 'Sort by',
        parent_directory: 'Parent directory',
        new_directory: 'New directory',
        edit_directory: 'Edit directory',
        directory: 'Directory',
        primary_directory: 'Primary directory',
        secondary_directory: 'Secondary directory',
        document_title: 'Title',
        vehicle_platform: 'Vehicle platform',
        status: 'Status',
        create_time: 'Create time',
        model: 'Model',
        attachment_name: 'File name',
        document_information: 'Document information',
        document_tag: 'Document tag',
        operation_record: 'Operation record',
        operating_time: 'Operating time',
        operator: 'Operator',
        publishing_department: 'Publishing department',
        publisher: 'Publisher',
        person_in_charge: 'Owner',
        remarks: 'Remarks',
        publish_objects: 'Release to',
        publish_mode: 'Release mode',
        whether_the_document_is_downloadable: 'Downloadable',
        release_status: 'Release status',
        case_label: 'Case Tags',
        left_frame: 'Left Drive',
        right_frame: 'Right Drive',
        cab_Position: 'Cab Position',
        release_time: 'Release Time',
        releases: 'Releases',
        regional_releases: 'Regional Releases',
        pending_approval: 'Pending Approval',
        import_date_list: 'Import Date List',
        holiday_name: 'Holiday Name',
        date: 'Date',
        country: 'Country',
        application_date: 'Application Date',
        approver: 'Approver',
        withdraw_approval: 'Withdraw Approval',
        national_holiday_application: 'National Holiday Application',
        submit_for_approval: 'Submit for Approval',
        holiday_date: 'Holiday Date',
        holiday_description: 'Holiday Description',
    },
    // 德
    deDE: {
        name: 'Name',
        sort: 'Sortierung',
        parent_directory: 'übergeordnetes Verzeichnis',
        new_directory: 'Neues Verzeichnis',
        edit_directory: 'Verzeichnis bearbeiten',
        directory: 'Verzeichnis',
        primary_directory: 'Hauptverzeichnis',
        secondary_directory: 'zweites Verzeichnis',
        document_title: 'Dokumententitel',
        vehicle_platform: 'Fahrzeugplattform',
        status: 'Status',
        create_time: 'Erstellungszeit',
        model: 'Modell',
        attachment_name: 'Dateiname',
        document_information: 'Dokumenteninformationen',
        document_tag: 'Dokumenten-Tag',
        operation_record: 'Betriebsaufzeichnung',
        operating_time: 'Betriebszeit',
        operator: 'Betriebsführer',
        publishing_department: 'Veröffentlichende Abteilung',
        publisher: 'Veröffentlicher',
        person_in_charge: 'Verantwortliche Person',
        remarks: 'Bemerkungen',
        publish_objects: 'Freigabe an',
        publish_mode: 'Freigabemodus',
        whether_the_document_is_downloadable: 'Ob das Dokument heruntergeladen werden kann',
        release_status: 'Freigabestatus',
        case_label: 'Fallmarken',
        left_frame: 'Linkslenker',
        right_frame: 'Rechtslenker',
        cab_Position: 'Fahrerhausposition',
        release_time: 'Veröffentlichungszeit',
        releases: 'Veröffentlichungen',
        regional_releases: 'Regionale Veröffentlichungen',
        pending_approval: 'Genehmigung ausstehend',
        import_date_list: 'Datumsliste importieren',
        holiday_name: 'Feiertagsname',
        date: 'Datum',
        country: 'Land',
        application_date: 'Antragsdatum',
        approver: 'Genehmiger',
        withdraw_approval: 'Genehmigung zurückziehen',
        national_holiday_application: 'Antrag auf nationalen Feiertag',
        submit_for_approval: 'Zur Genehmigung einreichen',
        holiday_date: 'Feiertagsdatum',
        holiday_description: 'Feiertagsbeschreibung',
    },
    // 法
    frFR: {
        name: 'Nom du répertoire',
        sort: 'Tier par',
        parent_directory: 'Répertoire parent',
        new_directory: 'Nouveau dossier',
        edit_directory: 'Modifier le nom du dossier',
        directory: 'Dossier',
        primary_directory: 'Répertoire principal',
        secondary_directory: 'Répertoire secondaire',
        document_title: 'Titre',
        vehicle_platform: 'Plate-forme de véhicule',
        status: 'Statut',
        create_time: 'Temps de création',
        model: 'Modèle',
        attachment_name: 'Nom du fichier',
        document_information: 'Informations sur le document',
        document_tag: 'Tag du document',
        operation_record: 'Enregistrement des opérations',
        operating_time: 'Temps d\'\'opération',
        operator: 'Opérateur',
        publishing_department: 'Département de publication',
        publisher: 'Editeur',
        person_in_charge: 'Titulaire',
        remarks: 'Remarques',
        publish_objects: 'Publié pour',
        publish_mode: 'Mode de publication',
        whether_the_document_is_downloadable: 'Téléchargable',
        release_status: 'Statut de publication',
        case_label: 'Étiquettes de cas',
        left_frame: 'Volant à gauche',
        right_frame: 'Volant à droite',
        cab_Position: 'Position de la cabine',
        release_time: 'Heure de publication',
        releases: 'Versions ou Publications',
        regional_releases: 'Sorties régionales',
        pending_approval: 'En attente de validation',
        import_date_list: 'Importer la liste des dates',
        holiday_name: 'Nom du jour férié',
        date: 'Date',
        country: 'Pays',
        application_date: 'Date de demande',
        approver: 'Approbateur',
        withdraw_approval: 'Retirer la validation',
        national_holiday_application: 'Demande de jour férié national',
        submit_for_approval: 'Soumettre pour approbation',
        holiday_date: 'Date du jour férié',
        holiday_description: 'Description du jour férié',
    },
    // 意大利
    itIT: {
        name: 'Nome',
        sort: 'Ordinamento',
        parent_directory: 'Directory genitore',
        new_directory: 'Nuova directory',
        edit_directory: 'Modifica directory',
        directory: 'Directory del documento',
        primary_directory: 'Directory di primo livello',
        secondary_directory: 'Directory di secondo livello',
        document_title: 'Titolo del documento',
        vehicle_platform: 'Piattaforma veicolo',
        status: 'Stato',
        create_time: 'Data di creazione',
        model: 'Modello',
        attachment_name: 'Nome allegato',
        document_information: 'Informazioni documento',
        document_tag: 'Tag del documento',
        operation_record: 'Registro operazioni',
        operating_time: 'Tempo di operazione',
        operator: 'Operatore',
        publishing_department: 'Reparto pubblicazioni',
        publisher: 'Pubblicatore',
        person_in_charge: 'Responsabile',
        remarks: 'Note',
        publish_objects: 'Oggetti di pubblicazione',
        publish_mode: 'Modalità di pubblicazione',
        whether_the_document_is_downloadable: 'Il documento è scaricabile?',
        release_status: 'Stato di pubblicazione',
        case_label: 'Etichette dei casi',
        left_frame: 'Volante a sinistra',
        right_frame: 'Volante a destra',
        cab_Position: 'Posizione della cabina',
        release_time: 'Ora di rilascio',
        releases: 'Rilasci',
        regional_releases: 'Rilasci regionali',
        pending_approval: 'In attesa di approvazione',
        import_date_list: 'Importa lista date',
        holiday_name: 'Nome festività',
        date: 'Data',
        country: 'Paese',
        application_date: 'Data della richiesta',
        approver: 'Approvatore',
        withdraw_approval: 'Ritira approvazione',
        national_holiday_application: 'Richiesta festività nazionale',
        submit_for_approval: 'Invia per approvazione',
        holiday_date: 'Data della festività',
        holiday_description: 'Descrizione della festività',
    },
    // 荷兰
    nlNL: {
        name: 'Naam',
        sort: 'Sorteren',
        parent_directory: 'Ouder directory',
        new_directory: 'Nieuwe directory',
        edit_directory: 'Bewerk directory',
        directory: 'Directory',
        primary_directory: 'Primaire directory',
        secondary_directory: 'Secundaire directory',
        document_title: 'Document titel',
        vehicle_platform: 'Voertuig platform',
        status: 'Status',
        create_time: 'Aanmaaktijd',
        model: 'Model',
        attachment_name: 'Bestandsnaam',
        document_information: 'Document informatie',
        document_tag: 'Document tag',
        operation_record: 'Bedieningsrecord',
        operating_time: 'Bedieningstijd',
        operator: 'Operator',
        publishing_department: 'Publicatie afdeling',
        publisher: 'Uitgever',
        person_in_charge: 'Verantwoordelijke persoon',
        remarks: 'Opmerkingen',
        publish_objects: 'Publiceer naar',
        publish_mode: 'Publiceer modus',
        whether_the_document_is_downloadable: 'Of het document downloadbaar is',
        release_status: 'Publicatie status',
        case_label: 'Case-tags',
        left_frame: 'Links stuur',
        right_frame: 'Rechts stuur',
        cab_Position: 'Cabine positie',
        release_time: 'Vrijgavetijd',
        releases: 'Releases of Publicaties',
        regional_releases: 'Regionale releases',
        pending_approval: 'Goedkeuring in afwachting',
        import_date_list: 'Importeer datumslijst',
        holiday_name: 'Naam feestdag',
        date: 'Datum',
        country: 'Land',
        application_date: 'Aanvraagdatum',
        approver: 'Goedkeurder',
        withdraw_approval: 'Goedkeuring intrekken',
        national_holiday_application: 'Aanvraag nationale feestdag',
        submit_for_approval: 'Inzenden voor goedkeuring',
        holiday_date: 'Feestdagdatum',
        holiday_description: 'Beschrijving van feestdag',
    },
    // 越南
    viVN: {
        name: 'Tên thư mục',
        sort: 'Sắp xếp bởi',
        parent_directory: 'Thư mục cha',
        new_directory: 'Tạo thư mục mới',
        edit_directory: 'Chỉnh sửa thư mục',
        directory: 'Thư mục tài liệu',
        primary_directory: 'Thư mục chính',
        secondary_directory: 'Thư mục phụ',
        document_title: 'Tiêu đề',
        vehicle_platform: 'Nền tảng xe',
        status: 'Trạng thái',
        create_time: 'Thời gian tạo',
        model: 'Loại xe',
        attachment_name: 'Tên tệp đính kèm',
        document_information: 'Thông tin tài liệu',
        document_tag: 'Thẻ tài liệu',
        operation_record: 'Lịch sử hoạt động',
        operating_time: 'Thời gian hoạt động',
        operator: 'Người thao tác',
        publishing_department: 'Bô phận phát hành',
        publisher: 'Nhà xuất bản',
        person_in_charge: 'Chủ sở hữu',
        remarks: 'Ghi chú',
        publish_objects: 'Phát hành tới',
        publish_mode: 'Chế độ phát hành',
        whether_the_document_is_downloadable: 'Có thể tải về',
        release_status: 'Trạng thái phát hành',
        case_label: 'Nhãn trường hợp',
        left_frame: 'Lái bên trái',
        right_frame: 'Lái bên phải',
        cab_Position: 'Vị trí cabin',
        release_time: 'Thời gian phát hành',
        releases: 'Phiên bản hoặc Phát hành',
        regional_releases: 'Phát hành khu vực',
        pending_approval: 'Chờ duyệt',
        import_date_list: 'Nhập danh sách ngày',
        holiday_name: 'Tên ngày lễ',
        date: 'Ngày',
        country: 'Quốc gia',
        application_date: 'Ngày nộp đơn',
        approver: 'Người phê duyệt',
        withdraw_approval: 'Rút lại phê duyệt',
        national_holiday_application: 'Yêu cầu nghỉ lễ quốc gia',
        submit_for_approval: 'Gửi để duyệt',
        holiday_date: 'Ngày lễ',
        holiday_description: 'Mô tả ngày lễ',
    },
    // 西班牙
    esES: {
        name: 'Nombre',
        sort: 'Orden',
        parent_directory: 'Directorio superior',
        new_directory: 'Crear directorio',
        edit_directory: 'Editar directorio',
        directory: 'Directorio de documentos',
        primary_directory: 'Directorio de nivel 1',
        secondary_directory: 'Directorio de nivel 2',
        document_title: 'Título del documento',
        vehicle_platform: 'Plataforma del vehículo',
        status: 'Estado',
        create_time: 'Fecha de creación',
        model: 'Modelo de vehículo',
        attachment_name: 'Nombre del adjunto',
        document_information: 'Información del documento',
        document_tag: 'Etiquetas del documento',
        operation_record: 'Registro de operaciones',
        operating_time: 'Fecha de operación',
        operator: 'Persona que realizó la operación',
        publishing_department: 'Departamento de publicación',
        publisher: 'Persona que publica',
        person_in_charge: 'Persona responsable',
        remarks: 'Observaciones',
        publish_objects: 'Destinatarios de la publicación',
        publish_mode: 'Modo de publicación',
        whether_the_document_is_downloadable: 'Posibilidad de descargar el documento',
        release_status: 'Estado de publicación',
        case_label: 'Etiquetas de caso',
        left_frame: 'Conducción a la izquierda',
        right_frame: 'Conducción a la derecha',
        cab_Position: 'Posición de la cabina',
        release_time: 'Hora de lanzamiento',
        releases: 'Lanzamientos',
        regional_releases: 'Lanzamientos regionales',
        pending_approval: 'Pendiente de aprobación',
        import_date_list: 'Importar lista de fechas',
        holiday_name: 'Nombre del festivo',
        date: 'Fecha',
        country: 'País',
        application_date: 'Fecha de solicitud',
        approver: 'Aprobador',
        withdraw_approval: 'Retirar aprobación',
        national_holiday_application: 'Solicitud de festivo nacional',
        submit_for_approval: 'Enviar para aprobación',
        holiday_date: 'Fecha del festivo',
        holiday_description: 'Descripción del festivo',
    },
    // 葡萄牙
    ptBR: {
        name: 'Nome',
        sort: 'Ordenação',
        parent_directory: 'Diretório superior',
        new_directory: 'Criar novo diretório',
        edit_directory: 'Editar diretório',
        directory: 'Diretório de documentos',
        primary_directory: 'Diretório de nível 1',
        secondary_directory: 'Diretório de nível 2',
        document_title: 'Título do documento',
        vehicle_platform: 'Plataforma do veículo',
        status: 'Estado',
        create_time: 'Data de criação',
        model: 'Modelo do veículo',
        attachment_name: 'Nome do anexo',
        document_information: 'Informações do documento',
        document_tag: 'Tag do documento',
        operation_record: 'Registro de operação',
        operating_time: 'Tempo de operação',
        operator: 'Operador',
        publishing_department: 'Departamento de publicação',
        publisher: 'Publicador',
        person_in_charge: 'Responsável',
        remarks: 'Observações',
        publish_objects: 'Objetos de publicação',
        publish_mode: 'Modo de publicação',
        whether_the_document_is_downloadable: 'O documento pode ser baixado?',
        release_status: 'Status de publicação',
        case_label: 'Etiquetas de caso',
        left_frame: 'Condução à esquerda',
        right_frame: 'Condução à direita',
        cab_Position: 'Posição da cabine',
        release_time: 'Hora de lançamento',
        releases: 'Lançamentos',
        regional_releases: 'Lançamentos regionais',
        pending_approval: 'Pendente de aprovação',
        import_date_list: 'Importar lista de datas',
        holiday_name: 'Nome do feriado',
        date: 'Data',
        country: 'País',
        application_date: 'Data da solicitação',
        approver: 'Aprovador',
        withdraw_approval: 'Retirar aprovação',
        national_holiday_application: 'Solicitação de feriado nacional',
        submit_for_approval: 'Enviar para aprovação',
        holiday_date: 'Data do feriado',
        holiday_description: 'Descrição do feriado',
    },
    // 波兰
    plPL: {
        name: 'Nazwa katalogu',
        sort: 'Sortowanie',
        parent_directory: 'Katalog nadrzędny',
        new_directory: 'Nowy katalog',
        edit_directory: 'Edytuj katalog',
        directory: 'Katalog',
        primary_directory: 'Katalog główny',
        secondary_directory: 'Katalog dodatkowy',
        document_title: 'Tytuł',
        vehicle_platform: 'Platforma pojazdu',
        status: 'Status',
        create_time: 'Czas założenia',
        model: 'Model',
        attachment_name: 'Nazwa pliku',
        document_information: 'Informacje o dokumencie',
        document_tag: 'Znacznik dokumentu',
        operation_record: 'Zapis operacji',
        operating_time: 'Osoba publikująca',
        operator: 'Operator',
        publishing_department: 'Dział publikujący',
        publisher: 'Osoba publikująca',
        person_in_charge: 'Właściciel',
        remarks: 'Uwagi',
        publish_objects: 'Opublikowane do',
        publish_mode: 'Tryb publikacji',
        whether_the_document_is_downloadable: 'Czy można pobrać?',
        release_status: 'Status publikacji',
        case_label: 'Etykiety przypadków',
        left_frame: 'Kierowanie z lewej',
        right_frame: 'Kierowanie z prawej',
        cab_Position: 'Pozycja kabiny',
        release_time: 'Czas wydania',
        releases: 'Wydania',
        regional_releases: 'Wydania regionalne',
        pending_approval: 'Oczekuje na zatwierdzenie',
        import_date_list: 'Importuj listę dat',
        holiday_name: 'Nazwa święta',
        date: 'Data',
        country: 'Kraj',
        application_date: 'Data zgłoszenia',
        approver: 'Zatwierdzający',
        withdraw_approval: 'Wycofaj zatwierdzenie',
        national_holiday_application: 'Wniosek o dzień wolny od pracy',
        submit_for_approval: 'Prześlij do zatwierdzenia',
        holiday_date: 'Data święta',
        holiday_description: 'Opis święta',
    },
    // 土耳其
    trTR: {
        name: 'dizin adı',
        sort: 'Sort by',
        parent_directory: 'Üst dizini',
        new_directory: 'Yeni dizin',
        edit_directory: 'Dizini düzenle',
        directory: 'Dizin',
        primary_directory: 'İlk dizin',
        secondary_directory: 'İkinci dizin',
        document_title: 'Başlık',
        vehicle_platform: 'Araç platformu',
        status: 'Durum',
        create_time: 'Zaman oluştur',
        model: 'Model',
        attachment_name: 'Dosya adı',
        document_information: 'Belge bilgisi',
        document_tag: 'Belge etiketi',
        operation_record: 'Operasyon kayıtları',
        operating_time: 'Operasyon zamanı',
        operator: 'Operatör',
        publishing_department: 'Yayım departmanı',
        publisher: 'Yayıncı',
        person_in_charge: 'Sahibi',
        remarks: 'İşaretler',
        publish_objects: 'Yayınla',
        publish_mode: 'Yayınlama modu',
        whether_the_document_is_downloadable: 'İndirilebilir',
        release_status: 'Yayınlanma durumu',
        case_label: 'Vaka Etiketleri',
        left_frame: 'Sol sürüş',
        right_frame: 'Sağ sürüş',
        cab_Position: 'Kabin pozisyonu',
        release_time: 'Yayın zamanı',
        releases: 'Sürümler veya Yayınlar',
        regional_releases: 'Bölgesel yayınlar',
        pending_approval: 'Onay bekleniyor',
        import_date_list: 'Tarih listesini içe aktar',
        holiday_name: 'Tatil adı',
        date: 'Tarih',
        country: 'Ülke',
        application_date: 'Başvuru tarihi',
        approver: 'Onaylayan',
        withdraw_approval: 'Onayı geri çek',
        national_holiday_application: 'Ulusal tatil başvurusu',
        submit_for_approval: 'Onay için gönder',
        holiday_date: 'Tatil tarihi',
        holiday_description: 'Tatil açıklaması',
    },
    // 捷克语
    csCZ: {
        name: 'název dokumentu',
        sort: 'Seřazeno podle',
        parent_directory: 'Nadřazený dokument',
        new_directory: 'Nový dokument',
        edit_directory: 'Upravit dokument',
        directory: 'Adresář',
        primary_directory: 'Primární dokument',
        secondary_directory: 'Sekundární dokument',
        document_title: 'Název',
        vehicle_platform: 'Platforma vozidla',
        status: 'Status',
        create_time: 'Čas vytvoření',
        model: 'Model',
        attachment_name: 'Název souboru',
        document_information: 'Informace o dokumentu',
        document_tag: 'Označení dokumentu',
        operation_record: 'Záznam činnosti',
        operating_time: 'Pracovní čas',
        operator: 'Operátor',
        publishing_department: 'Vydávání publikací',
        publisher: 'Vydavatel',
        person_in_charge: 'Majitel',
        remarks: 'Poznámky',
        publish_objects: 'Uvolnění pro',
        publish_mode: 'Režim vydání',
        whether_the_document_is_downloadable: 'Ke stažení',
        release_status: 'Stav vydání',
        case_label: 'Case Tags',
        left_frame: 'Levé řízení',
        right_frame: 'Pravé řízení',
        cab_Position: 'Pozice kabiny',
        release_time: 'Čas vydání',
        releases: 'Vydání',
        regional_releases: 'Regionální vydání',
        pending_approval: 'Čeká na schválení',
        import_date_list: 'Importovat seznam dat',
        holiday_name: 'Název svátku',
        date: 'Datum',
        country: 'Země',
        application_date: 'Datum žádosti',
        approver: 'Schvalovatel',
        withdraw_approval: 'Stáhnout schválení',
        national_holiday_application: 'Žádost o státní svátek',
        submit_for_approval: 'Odeslat ke schválení',
        holiday_date: 'Datum svátku',
        holiday_description: 'Popis svátku',
    },
    // 匈牙利语
    huHU: {
        name: 'Könyvtár neve',
        sort: 'Rendezési elv',
        parent_directory: 'Szülőkönyvtár',
        new_directory: 'Új könyvtár',
        edit_directory: 'Könyvtár szerkesztése',
        directory: 'Könyvtár',
        primary_directory: 'Első szintű könyvtár',
        secondary_directory: 'Második szintű könyvtár',
        document_title: 'Cím',
        vehicle_platform: 'Járműplatform',
        status: 'Állapot',
        create_time: 'Létrehozás ideje',
        model: 'Modell',
        attachment_name: 'Fájlnév',
        document_information: 'Dokumentumadatok',
        document_tag: 'Dokumentumcímke',
        operation_record: 'Műveleti rekord',
        operating_time: 'Műveleti idő',
        operator: 'Kezelő',
        publishing_department: 'Közzétevő részleg',
        publisher: 'Közzétevő',
        person_in_charge: 'Tulajdonos',
        remarks: 'Megjegyzések',
        publish_objects: 'Közzétéve itt:',
        publish_mode: 'Közzétételi üzemmód',
        whether_the_document_is_downloadable: 'Letölthető',
        release_status: 'Kiadási állapot',
        case_label: 'Esetcímkék',
        left_frame: 'Baloldali vezetés',
        right_frame: 'Jobboldali vezetés',
        cab_Position: 'Fülke pozíció',
        release_time: 'Kiadási idő',
        releases: 'Kiadások',
        regional_releases: 'Regionális kiadások',
        pending_approval: 'Jóváhagyás függőben',
        import_date_list: 'Dátumlista importálása',
        holiday_name: 'Ünnep neve',
        date: 'Dátum',
        country: 'Ország',
        application_date: 'Kérelem dátuma',
        approver: 'Jóváhagyó',
        withdraw_approval: 'Jóváhagyás visszavonása',
        national_holiday_application: 'Nemzeti ünnep kérelme',
        submit_for_approval: 'Beküldés jóváhagyásra',
        holiday_date: 'Ünnep dátuma',
        holiday_description: 'Ünnep leírása',
    },
    // 俄罗斯
    ruRU: {
        name: 'Имя',
        sort: 'Сортировать по',
        parent_directory: 'Родительский каталог',
        new_directory: 'Новый каталог',
        edit_directory: 'Редактировать каталог',
        directory: 'Каталог',
        primary_directory: 'Основной каталог',
        secondary_directory: 'Вторичный каталог',
        document_title: 'Заголовок документа',
        vehicle_platform: 'Платформа автомобиля',
        status: 'Статус',
        create_time: 'Время создания',
        model: 'Модель',
        attachment_name: 'Имя файла',
        document_information: 'Информация о документе',
        document_tag: 'Метка документа',
        operation_record: 'Запись операций',
        operating_time: 'Время работы',
        operator: 'Оператор',
        publishing_department: 'Отдел публикации',
        publisher: 'Издатель',
        person_in_charge: 'Ответственный',
        remarks: 'Примечания',
        publish_objects: 'Опубликовать для',
        publish_mode: 'Режим публикации',
        whether_the_document_is_downloadable: 'Документ доступен для загрузки',
        release_status: 'Статус выпуска',
        case_label: 'Метка дела',
        left_frame: 'Левая рама',
        right_frame: 'Правая рама',
        cab_Position: 'Расположение кабины',
        release_time: 'Время выпуска',
        releases: 'Релизы',
        regional_releases: 'Региональные выпуски',
        pending_approval: 'Ожидает утверждения',
        import_date_list: 'Импортировать список дат',
        holiday_name: 'Название праздника',
        date: 'Дата',
        country: 'Страна',
        application_date: 'Дата заявки',
        approver: 'Утверждающий',
        withdraw_approval: 'Отозвать утверждение',
        national_holiday_application: 'Заявка на национальный праздник',
        submit_for_approval: 'Отправить на утверждение',
        holiday_date: 'Дата праздника',
        holiday_description: 'Описание праздника',
    },
    // 沙特阿拉伯
    arSA: {
        name: 'الاسم',
        sort: 'الترتيب',
        parent_directory: 'الدليل الأعلى',
        new_directory: 'إنشاء دليل جديد',
        edit_directory: 'تعديل الدليل',
        directory: 'دليل المستندات',
        primary_directory: 'الدليل من المستوى الأول',
        secondary_directory: 'الدليل من المستوى الثاني',
        document_title: 'عنوان المستند',
        vehicle_platform: 'منصة طراز المركبة',
        status: 'الحالة',
        create_time: 'وقت الإنشاء',
        model: 'طراز المركبة',
        attachment_name: 'اسم المرفق',
        document_information: 'معلومات المستند',
        document_tag: 'وسم المستند',
        operation_record: 'سجل العمليات',
        operating_time: 'وقت التشغيل',
        operator: 'المشغل',
        publishing_department: 'قسم النشر',
        publisher: 'الناشر',
        person_in_charge: 'المسؤول',
        remarks: 'ملاحظات',
        publish_objects: 'أهداف النشر',
        publish_mode: 'وضع النشر',
        whether_the_document_is_downloadable: 'هل يمكن تنزيل المستند؟',
        release_status: 'حالة النشر',
        case_label: 'وسم الحالة',
        left_frame: 'مقود يسار',
        right_frame: 'مقود يمين',
        cab_Position: 'موقع كابينة القيادة',
        release_time: 'وقت النشر',
        releases: 'الإصدارات',
        regional_releases: 'إصدارات إقليمية',
        pending_approval: 'بانتظار الموافقة',
        import_date_list: 'قائمة تواريخ الاستيراد',
        holiday_name: 'اسم العطلة',
        date: 'التاريخ',
        country: 'الدولة التابعة',
        application_date: 'تاريخ الطلب',
        approver: 'الموافق',
        withdraw_approval: 'سحب الموافقة',
        national_holiday_application: 'طلب عطلة وطنية',
        submit_for_approval: 'تقديم للموافقة',
        holiday_date: 'تاريخ العطلة',
        holiday_description: 'وصف العطلة',
    },
    // 保加利亚
    bgBG: {
        name: 'Име',
        sort: 'Сортиране',
        parent_directory: 'Родителска директория',
        new_directory: 'Нова директория',
        edit_directory: 'Редактиране на директория',
        directory: 'Директория на документи',
        primary_directory: 'Първостепенна директория',
        secondary_directory: 'Второстепенна директория',
        document_title: 'Заглавие на документа',
        vehicle_platform: 'Платформа на модела',
        status: 'Статус',
        create_time: 'Време на създаване',
        model: 'Модел',
        attachment_name: 'Име на прикачения файл',
        document_information: 'Информация за документа',
        document_tag: 'Етикет на документа',
        operation_record: 'Запис на операциите',
        operating_time: 'Време на операцията',
        operator: 'Оператор',
        publishing_department: 'Отдел за публикуване',
        publisher: 'Публикувал',
        person_in_charge: 'Отговорно лице',
        remarks: 'Бележки',
        publish_objects: 'Целеви получатели',
        publish_mode: 'Режим на публикуване',
        whether_the_document_is_downloadable: 'Дали документът може да бъде изтеглен?',
        release_status: 'Статус на публикуване',
        case_label: 'Етикет на случая',
        left_frame: 'Ляво управление',
        right_frame: 'Дясно управление',
        cab_Position: 'Позиция на кабината',
        release_time: 'Време на публикуване',
        releases: 'Версии',
        regional_releases: 'Регионални версии',
        pending_approval: 'Чака одобрение',
        import_date_list: 'Списък с дати на импортиране',
        holiday_name: 'Име на празника',
        date: 'Дата',
        country: 'Държава',
        application_date: 'Дата на заявката',
        approver: 'Одобрил',
        withdraw_approval: 'Оттегляне на одобрението',
        national_holiday_application: 'Заявка за национален празник',
        submit_for_approval: 'Изпращане за одобрение',
        holiday_date: 'Дата на празника',
        holiday_description: 'Описание на празника',
    },
    // 丹麦语
    daDK: {
        name: 'Navn',
        sort: 'Sortering',
        parent_directory: 'Overordnet mappe',
        new_directory: 'Ny mappe',
        edit_directory: 'Redigér mappe',
        directory: 'Dokumentmappe',
        primary_directory: 'Primær mappe',
        secondary_directory: 'Sekundær mappe',
        document_title: 'Dokumenttitel',
        vehicle_platform: 'Køretøjsplatform',
        status: 'Status',
        create_time: 'Oprettelsestidspunkt',
        model: 'Model',
        attachment_name: 'Vedhæftet filnavn',
        document_information: 'Dokumentinformation',
        document_tag: 'Dokumentmærkat',
        operation_record: 'Handlingslog',
        operating_time: 'Handlings tidspunkt',
        operator: 'Operatør',
        publishing_department: 'Udgivende afdeling',
        publisher: 'Udgiver',
        person_in_charge: 'Ansvarlig',
        remarks: 'Bemærkninger',
        publish_objects: 'Modtagere',
        publish_mode: 'Udgivelsestilstand',
        whether_the_document_is_downloadable: 'Kan dokumentet downloades?',
        release_status: 'Udgivelsesstatus',
        case_label: 'Sagsmærkat',
        left_frame: 'Venstrestyret',
        right_frame: 'Højrestyret',
        cab_Position: 'Kabineposition',
        release_time: 'Udgivelsestidspunkt',
        releases: 'Versioner',
        regional_releases: 'Regionale versioner',
        pending_approval: 'Afventer godkendelse',
        import_date_list: 'Liste over importdatoer',
        holiday_name: 'Helligdagsnavn',
        date: 'Dato',
        country: 'Land',
        application_date: 'Ansøgningsdato',
        approver: 'Godkender',
        withdraw_approval: 'Tilbagetræk godkendelse',
        national_holiday_application: 'Ansøgning om national helligdag',
        submit_for_approval: 'Indsend til godkendelse',
        holiday_date: 'Helligdagsdato',
        holiday_description: 'Beskrivelse af helligdag',
    },
    // 芬兰语
    fiFI: {
        name: 'Nimi',
        sort: 'Lajittelu',
        parent_directory: 'Yläkansio',
        new_directory: 'Uusi kansio',
        edit_directory: 'Muokkaa kansiota',
        directory: 'Asiakirjakansio',
        primary_directory: 'Ensimmäisen tason kansio',
        secondary_directory: 'Toisen tason kansio',
        document_title: 'Asiakirjan otsikko',
        vehicle_platform: 'Ajoneuvoplatformi',
        status: 'Tila',
        create_time: 'Luontiaika',
        model: 'Malli',
        attachment_name: 'Liitteen nimi',
        document_information: 'Asiakirjan tiedot',
        document_tag: 'Asiakirjan tunniste',
        operation_record: 'Toimintaloki',
        operating_time: 'Toiminta-aika',
        operator: 'Käyttäjä',
        publishing_department: 'Julkaisija (osasto)',
        publisher: 'Julkaisija',
        person_in_charge: 'Vastuuhenkilö',
        remarks: 'Huomautukset',
        publish_objects: 'Julkaisukohteet',
        publish_mode: 'Julkaisutila',
        whether_the_document_is_downloadable: 'Voidaanko asiakirja ladata?',
        release_status: 'Julkaisutila',
        case_label: 'Tapauksen tunniste',
        left_frame: 'Vasen ohjaus',
        right_frame: 'Oikea ohjaus',
        cab_Position: 'Ohjaamon sijainti',
        release_time: 'Julkaisuaika',
        releases: 'Versiot',
        regional_releases: 'Alueelliset versiot',
        pending_approval: 'Odottaa hyväksyntää',
        import_date_list: 'Tuontipäivämäärälista',
        holiday_name: 'Vapaapäivän nimi',
        date: 'Päivämäärä',
        country: 'Maa',
        application_date: 'Hakemuspäivämäärä',
        approver: 'Hyväksyjä',
        withdraw_approval: 'Peruuta hyväksyntä',
        national_holiday_application: 'Kansallisen vapaapäivän hakemus',
        submit_for_approval: 'Lähetä hyväksyttäväksi',
        holiday_date: 'Vapaapäivän päivämäärä',
        holiday_description: 'Vapaapäivän kuvaus',
    },
    // 繁体中文台湾
    zhTW: {
        name: '名稱',
        sort: '排序',
        parent_directory: '上級目錄',
        new_directory: '新建目錄',
        edit_directory: '編輯目錄',
        directory: '文件目錄',
        primary_directory: '一級目錄',
        secondary_directory: '二級目錄',
        document_title: '文件標題',
        vehicle_platform: '車型平台',
        status: '狀態',
        create_time: '建立時間',
        model: '車型',
        attachment_name: '附件名稱',
        document_information: '文件資訊',
        document_tag: '文件標籤',
        operation_record: '操作記錄',
        operating_time: '操作時間',
        operator: '操作人',
        publishing_department: '發布部門',
        publisher: '發布人',
        person_in_charge: '負責人',
        remarks: '備註',
        publish_objects: '發布對象',
        publish_mode: '發布模式',
        whether_the_document_is_downloadable: '文件是否可下載',
        release_status: '發布狀態',
        case_label: '案例標籤',
        left_frame: '左駕',
        right_frame: '右駕',
        cab_Position: '駕駛室位置',
        release_time: '發布時間',
        releases: '版本',
        regional_releases: '區域版本',
        pending_approval: '待審批',
        import_date_list: '匯入日期清單',
        holiday_name: '節假日名稱',
        date: '日期',
        country: '所屬國家',
        application_date: '申請日期',
        approver: '審批人',
        withdraw_approval: '撤回審批',
        national_holiday_application: '國家節假日申請',
        submit_for_approval: '提交審批',
        holiday_date: '節假日日期',
        holiday_description: '節假日說明',
    },
    // 克罗地亚
    hrHR: {
        name: 'Naziv',
        sort: 'Sortiranje',
        parent_directory: 'Nadređeni direktorij',
        new_directory: 'Novi direktorij',
        edit_directory: 'Uredi direktorij',
        directory: 'Direktorij dokumenata',
        primary_directory: 'Glavni direktorij',
        secondary_directory: 'Poddirektorij',
        document_title: 'Naslov dokumenta',
        vehicle_platform: 'Platforma vozila',
        status: 'Status',
        create_time: 'Vrijeme stvaranja',
        model: 'Model',
        attachment_name: 'Naziv priloga',
        document_information: 'Informacije o dokumentu',
        document_tag: 'Oznaka dokumenta',
        operation_record: 'Zapis radnji',
        operating_time: 'Vrijeme izvršenja',
        operator: 'Operater',
        publishing_department: 'Odjel za objavljivanje',
        publisher: 'Objavio',
        person_in_charge: 'Osoba odgovorna',
        remarks: 'Napomene',
        publish_objects: 'Ciljne osobe',
        publish_mode: 'Način objave',
        whether_the_document_is_downloadable: 'Je li dokument preuzimljiv?',
        release_status: 'Status objave',
        case_label: 'Oznaka slučaja',
        left_frame: 'Lijevi volan',
        right_frame: 'Desni volan',
        cab_Position: 'Položaj kabine',
        release_time: 'Vrijeme objave',
        releases: 'Verzije',
        regional_releases: 'Regionalne verzije',
        pending_approval: 'Na čekanju za odobrenje',
        import_date_list: 'Popis datuma uvoza',
        holiday_name: 'Naziv praznika',
        date: 'Datum',
        country: 'Država',
        application_date: 'Datum prijave',
        approver: 'Odobrio',
        withdraw_approval: 'Povuci odobrenje',
        national_holiday_application: 'Zahtjev za nacionalni praznik',
        submit_for_approval: 'Podnesi na odobrenje',
        holiday_date: 'Datum praznika',
        holiday_description: 'Opis praznika',
    },
    // 拉脱维亚
    lvLV: {
        name: 'Nosaukums',
        sort: 'Kārtot',
        parent_directory: 'Vecāka direktorijs',
        new_directory: 'Jauns direktorijs',
        edit_directory: 'Rediģēt direktoriju',
        directory: 'Dokumentu direktorijs',
        primary_directory: 'Pirmā līmeņa direktorijs',
        secondary_directory: 'Otrā līmeņa direktorijs',
        document_title: 'Dokumenta nosaukums',
        vehicle_platform: 'Transportlīdzekļa platforma',
        status: 'Statuss',
        create_time: 'Izveides laiks',
        model: 'Modelis',
        attachment_name: 'Pielikuma nosaukums',
        document_information: 'Dokumenta informācija',
        document_tag: 'Dokumenta birka',
        operation_record: 'Darbību žurnāls',
        operating_time: 'Darbības laiks',
        operator: 'Operators',
        publishing_department: 'Publicēšanas departaments',
        publisher: 'Publicētājs',
        person_in_charge: 'Atbildīgā persona',
        remarks: 'Piezīmes',
        publish_objects: 'Publicēšanas mērķi',
        publish_mode: 'Publicēšanas režīms',
        whether_the_document_is_downloadable: 'Vai dokumentu var lejupielādēt?',
        release_status: 'Publicēšanas statuss',
        case_label: 'Gadījuma birka',
        left_frame: 'Kreisā stūre',
        right_frame: 'Labā stūre',
        cab_Position: 'Kabīnes atrašanās vieta',
        release_time: 'Publicēšanas laiks',
        releases: 'Versijas',
        regional_releases: 'Reģionālās versijas',
        pending_approval: 'Gaida apstiprinājumu',
        import_date_list: 'Importēšanas datumu saraksts',
        holiday_name: 'Brīvdienas nosaukums',
        date: 'Datums',
        country: 'Valsts',
        application_date: 'Pieteikuma datums',
        approver: 'Apstiprinātājs',
        withdraw_approval: 'Atsaukt apstiprinājumu',
        national_holiday_application: 'Nacionālo brīvdienu pieteikums',
        submit_for_approval: 'Iesniegt apstiprināšanai',
        holiday_date: 'Brīvdienas datums',
        holiday_description: 'Brīvdienas apraksts',
    },
    // 立陶宛
    ltLT: {
        name: 'Pavadinimas',
        sort: 'Rūšiavimas',
        parent_directory: 'Aukštesnio lygio katalogas',
        new_directory: 'Naujas katalogas',
        edit_directory: 'Redaguoti katalogą',
        directory: 'Dokumentų katalogas',
        primary_directory: 'Pirmo lygio katalogas',
        secondary_directory: 'Antro lygio katalogas',
        document_title: 'Dokumento pavadinimas',
        vehicle_platform: 'Transporto priemonės platforma',
        status: 'Būsena',
        create_time: 'Sukūrimo laikas',
        model: 'Modelis',
        attachment_name: 'Priedo pavadinimas',
        document_information: 'Dokumento informacija',
        document_tag: 'Dokumento žyma',
        operation_record: 'Veiksmų žurnalas',
        operating_time: 'Veiksmo laikas',
        operator: 'Operatorius',
        publishing_department: 'Publikavimo skyrius',
        publisher: 'Publikuotojas',
        person_in_charge: 'Atsakingas asmuo',
        remarks: 'Pastabos',
        publish_objects: 'Publikavimo tikslai',
        publish_mode: 'Publikavimo režimas',
        whether_the_document_is_downloadable: 'Ar galima atsisiųsti dokumentą?',
        release_status: 'Publikavimo būsena',
        case_label: 'Atvejo žyma',
        left_frame: 'Kairinis valdymas',
        right_frame: 'Dešininis valdymas',
        cab_Position: 'Kabinos pozicija',
        release_time: 'Publikavimo laikas',
        releases: 'Versijos',
        regional_releases: 'Regioninės versijos',
        pending_approval: 'Laukiama patvirtinimo',
        import_date_list: 'Importavimo datų sąrašas',
        holiday_name: 'Šventės pavadinimas',
        date: 'Data',
        country: 'Šalis',
        application_date: 'Paraiškos data',
        approver: 'Patvirtinęs asmuo',
        withdraw_approval: 'Atšaukti patvirtinimą',
        national_holiday_application: 'Nacionalinės šventės paraiška',
        submit_for_approval: 'Pateikti patvirtinimui',
        holiday_date: 'Šventės data',
        holiday_description: 'Šventės aprašymas',
    },
    // 罗马尼亚
    roRO: {
        name: 'Nume',
        sort: 'Sortare',
        parent_directory: 'Director părinte',
        new_directory: 'Director nou',
        edit_directory: 'Editare director',
        directory: 'Director documente',
        primary_directory: 'Director de nivel 1',
        secondary_directory: 'Director de nivel 2',
        document_title: 'Titlul documentului',
        vehicle_platform: 'Platformă vehicul',
        status: 'Stare',
        create_time: 'Data creării',
        model: 'Model',
        attachment_name: 'Numele atașamentului',
        document_information: 'Informații document',
        document_tag: 'Etichetă document',
        operation_record: 'Jurnal operațiuni',
        operating_time: 'Timp operațiune',
        operator: 'Operator',
        publishing_department: 'Departamentul de publicare',
        publisher: 'Publicat de',
        person_in_charge: 'Persoana responsabilă',
        remarks: 'Observații',
        publish_objects: 'Destinatari',
        publish_mode: 'Mod de publicare',
        whether_the_document_is_downloadable: 'Documentul poate fi descărcat?',
        release_status: 'Stare publicare',
        case_label: 'Etichetă caz',
        left_frame: 'Volan stânga',
        right_frame: 'Volan dreapta',
        cab_Position: 'Poziția cabinei',
        release_time: 'Data publicării',
        releases: 'Versiuni',
        regional_releases: 'Versiuni regionale',
        pending_approval: 'În așteptarea aprobării',
        import_date_list: 'Listă date import',
        holiday_name: 'Nume sărbătoare',
        date: 'Dată',
        country: 'Țară',
        application_date: 'Data solicitării',
        approver: 'Aprobat de',
        withdraw_approval: 'Retrage aprobarea',
        national_holiday_application: 'Solicitare sărbătoare națională',
        submit_for_approval: 'Trimite spre aprobare',
        holiday_date: 'Data sărbătorii',
        holiday_description: 'Descriere sărbătoare',
    },
    // 挪威博克马尔
    nbNO: {
        name: 'Navn',
        sort: 'Sortering',
        parent_directory: 'Overordnet mappe',
        new_directory: 'Ny mappe',
        edit_directory: 'Rediger mappe',
        directory: 'Dokumentmappe',
        primary_directory: 'Hovedmappe',
        secondary_directory: 'Undermappe',
        document_title: 'Dokumenttittel',
        vehicle_platform: 'Kjøretøyplattform',
        status: 'Status',
        create_time: 'Opprettet',
        model: 'Modell',
        attachment_name: 'Vedleggnavn',
        document_information: 'Dokumentinformasjon',
        document_tag: 'Dokumentmerke',
        operation_record: 'Operasjonslogg',
        operating_time: 'Operasjonstidspunkt',
        operator: 'Operatør',
        publishing_department: 'Publiseringsavdeling',
        publisher: 'Utgiver',
        person_in_charge: 'Ansvarlig',
        remarks: 'Merknader',
        publish_objects: 'Mottakere',
        publish_mode: 'Publiseringsmodus',
        whether_the_document_is_downloadable: 'Kan dokumentet lastes ned?',
        release_status: 'Publiseringsstatus',
        case_label: 'Saksmerke',
        left_frame: 'Venstrestyrt',
        right_frame: 'Høyrestyrt',
        cab_Position: 'Førerkabinens posisjon',
        release_time: 'Publiseringstidspunkt',
        releases: 'Versjoner',
        regional_releases: 'Regionale versjoner',
        pending_approval: 'Avventer godkjenning',
        import_date_list: 'Liste over importdatoer',
        holiday_name: 'Helligdagsnavn',
        date: 'Dato',
        country: 'Land',
        application_date: 'Søknadsdato',
        approver: 'Godkjenner',
        withdraw_approval: 'Trekke tilbake godkjenning',
        national_holiday_application: 'Søknad om nasjonal helligdag',
        submit_for_approval: 'Send inn for godkjenning',
        holiday_date: 'Helligdagsdato',
        holiday_description: 'Beskrivelse av helligdag',
    },
    // 葡萄牙语巴西
    ptBX: {
        name: 'Nome',
        sort: 'Ordenação',
        parent_directory: 'Diretório superior',
        new_directory: 'Novo diretório',
        edit_directory: 'Editar diretório',
        directory: 'Diretório de documentos',
        primary_directory: 'Diretório de nível 1',
        secondary_directory: 'Diretório de nível 2',
        document_title: 'Título do documento',
        vehicle_platform: 'Plataforma do modelo',
        status: 'Status',
        create_time: 'Data de criação',
        model: 'Modelo',
        attachment_name: 'Nome do anexo',
        document_information: 'Informações do documento',
        document_tag: 'Etiqueta do documento',
        operation_record: 'Registro de operações',
        operating_time: 'Horário da operação',
        operator: 'Operador',
        publishing_department: 'Departamento de Publicação',
        publisher: 'Publicado por',
        person_in_charge: 'Responsável',
        remarks: 'Observações',
        publish_objects: 'Destinatários',
        publish_mode: 'Modo de publicação',
        whether_the_document_is_downloadable: 'O documento pode ser baixado?',
        release_status: 'Status de publicação',
        case_label: 'Etiqueta do caso',
        left_frame: 'Volante à esquerda',
        right_frame: 'Volante à direita',
        cab_Position: 'Posição da cabine',
        release_time: 'Data de publicação',
        releases: 'Versões',
        regional_releases: 'Versões regionais',
        pending_approval: 'Aguardando aprovação',
        import_date_list: 'Lista de datas de importação',
        holiday_name: 'Nome do feriado',
        date: 'Data',
        country: 'País',
        application_date: 'Data da solicitação',
        approver: 'Aprovador',
        withdraw_approval: 'Retirar aprovação',
        national_holiday_application: 'Solicitação de feriado nacional',
        submit_for_approval: 'Enviar para aprovação',
        holiday_date: 'Data do feriado',
        holiday_description: 'Descrição do feriado',
    },
    // 瑞典语
    svSE: {
        name: 'Namn',
        sort: 'Sortering',
        parent_directory: 'Överordnad mapp',
        new_directory: 'Ny mapp',
        edit_directory: 'Redigera mapp',
        directory: 'Dokumentmapp',
        primary_directory: 'Huvudmapp',
        secondary_directory: 'Undermapp',
        document_title: 'Dokumenttitel',
        vehicle_platform: 'Fordonsplattform',
        status: 'Status',
        create_time: 'Skapad',
        model: 'Modell',
        attachment_name: 'Bifogat filnamn',
        document_information: 'Dokumentinformation',
        document_tag: 'Dokumenttagg',
        operation_record: 'Åtgärdslogg',
        operating_time: 'Åtgärdstidpunkt',
        operator: 'Operatör',
        publishing_department: 'Publiceringsavdelning',
        publisher: 'Utgivare',
        person_in_charge: 'Ansvarig',
        remarks: 'Anmärkningar',
        publish_objects: 'Mottagare',
        publish_mode: 'Publiceringsläge',
        whether_the_document_is_downloadable: 'Kan dokumentet laddas ner?',
        release_status: 'Publiceringsstatus',
        case_label: 'Ärendetagg',
        left_frame: 'Vänsterstyrning',
        right_frame: 'Högerstyrning',
        cab_Position: 'Kabinplacering',
        release_time: 'Publiceringstidpunkt',
        releases: 'Versioner',
        regional_releases: 'Regionala versioner',
        pending_approval: 'Väntar på godkännande',
        import_date_list: 'Lista över importdatum',
        holiday_name: 'Helgdagsnamn',
        date: 'Datum',
        country: 'Land',
        application_date: 'Ansökningsdatum',
        approver: 'Godkännare',
        withdraw_approval: 'Återkalla godkännande',
        national_holiday_application: 'Ansökan om nationell helgdag',
        submit_for_approval: 'Skicka för godkännande',
        holiday_date: 'Helgdagsdatum',
        holiday_description: 'Beskrivning av helgdag',
    },
    // 斯洛伐克
    skSK: {
        name: 'Názov',
        sort: 'Zoradenie',
        parent_directory: 'Nadradený adresár',
        new_directory: 'Nový adresár',
        edit_directory: 'Upraviť adresár',
        directory: 'Adresár dokumentov',
        primary_directory: 'Adresár prvej úrovne',
        secondary_directory: 'Adresár druhej úrovne',
        document_title: 'Názov dokumentu',
        vehicle_platform: 'Platforma vozidla',
        status: 'Stav',
        create_time: 'Čas vytvorenia',
        model: 'Model',
        attachment_name: 'Názov prílohy',
        document_information: 'Informácie o dokumente',
        document_tag: 'Štítok dokumentu',
        operation_record: 'Záznam operácií',
        operating_time: 'Čas operácie',
        operator: 'Operátor',
        publishing_department: 'Oddelenie pre zverejňovanie',
        publisher: 'Zverejnil',
        person_in_charge: 'Zodpovedná osoba',
        remarks: 'Poznámky',
        publish_objects: 'Cieľové skupiny',
        publish_mode: 'Režim zverejnenia',
        whether_the_document_is_downloadable: 'Je dokument stiahnuteľný?',
        release_status: 'Stav zverejnenia',
        case_label: 'Štítok prípadu',
        left_frame: 'Ľavé riadenie',
        right_frame: 'Pravé riadenie',
        cab_Position: 'Pozícia kabíny',
        release_time: 'Čas zverejnenia',
        releases: 'Verzie',
        regional_releases: 'Regionálne verzie',
        pending_approval: 'Čaká na schválenie',
        import_date_list: 'Zoznam dátumov importu',
        holiday_name: 'Názov sviatku',
        date: 'Dátum',
        country: 'Krajina',
        application_date: 'Dátum žiadosti',
        approver: 'Schvaľovateľ',
        withdraw_approval: 'Stiahnuť schválenie',
        national_holiday_application: 'Žiadosť o národný sviatok',
        submit_for_approval: 'Odoslať na schválenie',
        holiday_date: 'Dátum sviatku',
        holiday_description: 'Popis sviatku',
    },
    // 斯洛文尼亚
    slSI: {
        name: 'Ime',
        sort: 'Razvrščanje',
        parent_directory: 'Nadrejeni imenik',
        new_directory: 'Nov imenik',
        edit_directory: 'Uredi imenik',
        directory: 'Imenik dokumentov',
        primary_directory: 'Imenik prve ravni',
        secondary_directory: 'Imenik druge ravni',
        document_title: 'Naslov dokumenta',
        vehicle_platform: 'Platforma vozila',
        status: 'Stanje',
        create_time: 'Čas ustvarjanja',
        model: 'Model',
        attachment_name: 'Ime priponke',
        document_information: 'Podatki o dokumentu',
        document_tag: 'Oznaka dokumenta',
        operation_record: 'Dnevnik operacij',
        operating_time: 'Čas operacije',
        operator: 'Operater',
        publishing_department: 'Oddel za objavo',
        publisher: 'Objavil',
        person_in_charge: 'Odgovorna oseba',
        remarks: 'Opombe',
        publish_objects: 'Ciljne skupine',
        publish_mode: 'Način objave',
        whether_the_document_is_downloadable: 'Ali je dokument prenosljiv?',
        release_status: 'Stanje objave',
        case_label: 'Oznaka primera',
        left_frame: 'Levi volan',
        right_frame: 'Desni volan',
        cab_Position: 'Položaj kabine',
        release_time: 'Čas objave',
        releases: 'Različice',
        regional_releases: 'Regionalne različice',
        pending_approval: 'Na čakanju za odobritev',
        import_date_list: 'Seznam datumov uvoza',
        holiday_name: 'Ime praznika',
        date: 'Datum',
        country: 'Država',
        application_date: 'Datum vloge',
        approver: 'Odobril',
        withdraw_approval: 'Umakni odobritev',
        national_holiday_application: 'Vloga za nacionalni praznik',
        submit_for_approval: 'Pošlji v odobritev',
        holiday_date: 'Datum praznika',
        holiday_description: 'Opis praznika',
    },
    // 泰语
    thTH: {
        name: 'ชื่อ',
        sort: 'เรียงลำดับ',
        parent_directory: 'ไดเรกทอรีหลัก',
        new_directory: 'สร้างไดเรกทอรีใหม่',
        edit_directory: 'แก้ไขไดเรกทอรี',
        directory: 'ไดเรกทอรีเอกสาร',
        primary_directory: 'ไดเรกทอรีระดับ 1',
        secondary_directory: 'ไดเรกทอรีระดับ 2',
        document_title: 'ชื่อเอกสาร',
        vehicle_platform: 'แพลตฟอร์มรุ่นรถ',
        status: 'สถานะ',
        create_time: 'เวลาสร้าง',
        model: 'รุ่นรถ',
        attachment_name: 'ชื่อไฟล์แนบ',
        document_information: 'ข้อมูลเอกสาร',
        document_tag: 'ป้ายกำกับเอกสาร',
        operation_record: 'ประวัติการดำเนินการ',
        operating_time: 'เวลาดำเนินการ',
        operator: 'ผู้ดำเนินการ',
        publishing_department: 'หน่วยงานผู้ประกาศ',
        publisher: 'ผู้ประกาศ',
        person_in_charge: 'ผู้รับผิดชอบ',
        remarks: 'หมายเหตุ',
        publish_objects: 'กลุ่มเป้าหมาย',
        publish_mode: 'รูปแบบการประกาศ',
        whether_the_document_is_downloadable: 'เอกสารสามารถดาวน์โหลดได้หรือไม่',
        release_status: 'สถานะการเผยแพร่',
        case_label: 'ป้ายกำกับกรณีศึกษา',
        left_frame: 'พวงมาลัยซ้าย',
        right_frame: 'พวงมาลัยขวา',
        cab_Position: 'ตำแหน่งห้องโดยสาร',
        release_time: 'เวลาเผยแพร่',
        releases: 'เวอร์ชัน',
        regional_releases: 'เวอร์ชันตามภูมิภาค',
        pending_approval: 'รอการอนุมัติ',
        import_date_list: 'รายการวันที่นำเข้า',
        holiday_name: 'ชื่อวันหยุด',
        date: 'วันที่',
        country: 'ประเทศ',
        application_date: 'วันที่ยื่นคำขอ',
        approver: 'ผู้อนุมัติ',
        withdraw_approval: 'ถอนการอนุมัติ',
        national_holiday_application: 'คำขอวันหยุดราชการ',
        submit_for_approval: 'ส่งขออนุมัติ',
        holiday_date: 'วันที่หยุด',
        holiday_description: 'รายละเอียดวันหยุด',
    },
    // 乌克兰语
    ukUA: {
        name: 'Назва',
        sort: 'Сортування',
        parent_directory: 'Батьківський каталог',
        new_directory: 'Новий каталог',
        edit_directory: 'Редагувати каталог',
        directory: 'Каталог документів',
        primary_directory: 'Каталог першого рівня',
        secondary_directory: 'Каталог другого рівня',
        document_title: 'Заголовок документа',
        vehicle_platform: 'Платформа моделі автомобіля',
        status: 'Статус',
        create_time: 'Час створення',
        model: 'Модель',
        attachment_name: 'Назва вкладення',
        document_information: 'Інформація про документ',
        document_tag: 'Мітка документа',
        operation_record: 'Журнал операцій',
        operating_time: 'Час операції',
        operator: 'Оператор',
        publishing_department: 'Відділ публікації',
        publisher: 'Опублікував',
        person_in_charge: 'Відповідальна особа',
        remarks: 'Примітки',
        publish_objects: 'Цільові отримувачі',
        publish_mode: 'Режим публікації',
        whether_the_document_is_downloadable: 'Чи можна завантажити документ?',
        release_status: 'Статус публікації',
        case_label: 'Мітка випадку',
        left_frame: 'Ліве кермо',
        right_frame: 'Праве кермо',
        cab_Position: 'Розташування кабіни',
        release_time: 'Час публікації',
        releases: 'Версії',
        regional_releases: 'Регіональні версії',
        pending_approval: 'Очікує затвердження',
        import_date_list: 'Список дат імпорту',
        holiday_name: 'Назва свята',
        date: 'Дата',
        country: 'Країна',
        application_date: 'Дата подання',
        approver: 'Затвердив',
        withdraw_approval: 'Скасувати затвердження',
        national_holiday_application: 'Заява на національне свято',
        submit_for_approval: 'Надіслати на затвердження',
        holiday_date: 'Дата свята',
        holiday_description: 'Опис свята',
    },
    // 希腊语
    elGR: {
        name: 'Όνομα',
        sort: 'Ταξινόμηση',
        parent_directory: 'Γονικός φάκελος',
        new_directory: 'Νέος φάκελος',
        edit_directory: 'Επεξεργασία φακέλου',
        directory: 'Φάκελος εγγράφων',
        primary_directory: 'Φάκελος πρώτου επιπέδου',
        secondary_directory: 'Φάκελος δεύτερου επιπέδου',
        document_title: 'Τίτλος εγγράφου',
        vehicle_platform: 'Πλατφόρμα οχήματος',
        status: 'Κατάσταση',
        create_time: 'Ώρα δημιουργίας',
        model: 'Μοντέλο',
        attachment_name: 'Όνομα συνημμένου',
        document_information: 'Πληροφορίες εγγράφου',
        document_tag: 'Ετικέτα εγγράφου',
        operation_record: 'Καταγραφή λειτουργιών',
        operating_time: 'Ώρα λειτουργίας',
        operator: 'Χειριστής',
        publishing_department: 'Τμήμα Δημοσίευσης',
        publisher: 'Δημοσιευτής',
        person_in_charge: 'Υπεύθυνος',
        remarks: 'Σχόλια',
        publish_objects: 'Αποδέκτες',
        publish_mode: 'Λειτουργία δημοσίευσης',
        whether_the_document_is_downloadable: 'Το έγγραφο μπορεί να ληφθεί;',
        release_status: 'Κατάσταση δημοσίευσης',
        case_label: 'Ετικέτα περίπτωσης',
        left_frame: 'Αριστερό τιμόνι',
        right_frame: 'Δεξί τιμόνι',
        cab_Position: 'Θέση καμπίνας',
        release_time: 'Ώρα δημοσίευσης',
        releases: 'Εκδόσεις',
        regional_releases: 'Περιφερειακές εκδόσεις',
        pending_approval: 'Σε αναμονή έγκρισης',
        import_date_list: 'Λίστα ημερομηνιών εισαγωγής',
        holiday_name: 'Όνομα αργίας',
        date: 'Ημερομηνία',
        country: 'Χώρα',
        application_date: 'Ημερομηνία αίτησης',
        approver: 'Εγκρίνων',
        withdraw_approval: 'Ανάκληση έγκρισης',
        national_holiday_application: 'Αίτηση για εθνική αργία',
        submit_for_approval: 'Υποβολή για έγκριση',
        holiday_date: 'Ημερομηνία αργίας',
        holiday_description: 'Περιγραφή αργίας',
    },
    // 爱沙尼亚
    etEE: {
        name: 'Nimi',
        sort: 'Sortimine',
        parent_directory: 'Ülemkataloog',
        new_directory: 'Uus kataloog',
        edit_directory: 'Muuda kataloogi',
        directory: 'Dokumentide kataloog',
        primary_directory: 'Esimese taseme kataloog',
        secondary_directory: 'Teise taseme kataloog',
        document_title: 'Dokumendi pealkiri',
        vehicle_platform: 'Sõiduki platvorm',
        status: 'Olek',
        create_time: 'Loomise aeg',
        model: 'Mudel',
        attachment_name: 'Manuse nimi',
        document_information: 'Dokumendi andmed',
        document_tag: 'Dokumendi silt',
        operation_record: 'Tegevuste logi',
        operating_time: 'Tegevuse aeg',
        operator: 'Operaator',
        publishing_department: 'Avaldamise osakond',
        publisher: 'Avaldanud',
        person_in_charge: 'Vastutaja',
        remarks: 'Märkused',
        publish_objects: 'Sihtgrupid',
        publish_mode: 'Avaldamise režiim',
        whether_the_document_is_downloadable: 'Kas dokument on allalaaditav?',
        release_status: 'Avaldamise olek',
        case_label: 'Juhtumi silt',
        left_frame: 'Vasakpoolne rool',
        right_frame: 'Paremoolne rool',
        cab_Position: 'Kabiini asukoht',
        release_time: 'Avaldamise aeg',
        releases: 'Versioonid',
        regional_releases: 'Regionaalsed versioonid',
        pending_approval: 'Ootab heakskiitu',
        import_date_list: 'Impordikuupäevade loend',
        holiday_name: 'Puhkepäeva nimi',
        date: 'Kuupäev',
        country: 'Riik',
        application_date: 'Taotluse esitamise kuupäev',
        approver: 'Heakskiitja',
        withdraw_approval: 'Tühista heakskiit',
        national_holiday_application: 'Rahvusliku puhkepäeva taotlus',
        submit_for_approval: 'Esita heakskiiduks',
        holiday_date: 'Puhkepäeva kuupäev',
        holiday_description: 'Puhkepäeva kirjeldus',
    },
    // 哈萨克
    kkKZ: {
        name: 'Атауы',
        sort: 'Сұрыптау',
        parent_directory: 'Жоғары деңгейлі каталог',
        new_directory: 'Жаңа каталог',
        edit_directory: 'Каталогты өңдеу',
        directory: 'Құжаттар каталогы',
        primary_directory: 'Бірінші деңгейлі каталог',
        secondary_directory: 'Екінші деңгейлі каталог',
        document_title: 'Құжат атауы',
        vehicle_platform: 'Автокөлік платформасы',
        status: 'Мәртебесі',
        create_time: 'Жасалған уақыты',
        model: 'Моделі',
        attachment_name: 'Салынған файл атауы',
        document_information: 'Құжат туралы ақпарат',
        document_tag: 'Құжат белгісі',
        operation_record: 'Әрекеттер журналы',
        operating_time: 'Әрекет уақыты',
        operator: 'Оператор',
        publishing_department: 'Баспа бөлімі',
        publisher: 'Жариялаушы',
        person_in_charge: 'Жауапты тұлға',
        remarks: 'Ескертпелер',
        publish_objects: 'Жариялау объектілері',
        publish_mode: 'Жариялау режимі',
        whether_the_document_is_downloadable: 'Құжатты жүктеп алуға бола ма?',
        release_status: 'Жариялау мәртебесі',
        case_label: 'Жағдай белгісі',
        left_frame: 'Сол жақтағы басқару',
        right_frame: 'Оң жақтағы басқару',
        cab_Position: 'Кабина орны',
        release_time: 'Жарияланған уақыты',
        releases: 'Нұсқалар',
        regional_releases: 'Аймақтық нұсқалар',
        pending_approval: 'Бекіту күтілуде',
        import_date_list: 'Импорттау күндері тізімі',
        holiday_name: 'Мейрам атауы',
        date: 'Күні',
        country: 'Ел',
        application_date: 'Өтініш берілген күні',
        approver: 'Бекіткен адам',
        withdraw_approval: 'Бекітуді болдырмау',
        national_holiday_application: 'Ұлттық мейрамға өтініш',
        submit_for_approval: 'Бекітуге жіберу',
        holiday_date: 'Мейрам күні',
        holiday_description: 'Мейрам сипаттамасы',
    },
    // 希伯来语
    heIL: {
        name: 'שם',
        sort: 'מיון',
        parent_directory: 'תיקיה עלונה',
        new_directory: 'תיקיה חדשה',
        edit_directory: 'עריכת תיקיה',
        directory: 'תיקיית מסמכים',
        primary_directory: 'תיקיית רמה ראשונה',
        secondary_directory: 'תיקיית רמה שנייה',
        document_title: 'כותרת המסמך',
        vehicle_platform: 'פלטפורמת דגם הרכב',
        status: 'סטטוס',
        create_time: 'זמן יצירה',
        model: 'דגם',
        attachment_name: 'שם הקובץ המצורף',
        document_information: 'פרטי המסמך',
        document_tag: 'תגית מסמך',
        operation_record: 'יומן פעולות',
        operating_time: 'זמן פעולה',
        operator: 'מפעיל',
        publishing_department: 'מחלקת פרסום',
        publisher: 'מפרסם',
        person_in_charge: 'אחראי',
        remarks: 'הערות',
        publish_objects: 'יעדי פרסום',
        publish_mode: 'מצב פרסום',
        whether_the_document_is_downloadable: 'האם ניתן להוריד את המסמך?',
        release_status: 'סטטוס פרסום',
        case_label: 'תגית מקרה',
        left_frame: 'הגה שמאלי',
        right_frame: 'הגה ימני',
        cab_Position: 'מיקום תיבת הנהג',
        release_time: 'זמן פרסום',
        releases: 'גרסאות',
        regional_releases: 'גרסאות אזוריות',
        pending_approval: 'ממתין לאישור',
        import_date_list: 'רשימת תאריכי ייבוא',
        holiday_name: 'שם החג',
        date: 'תאריך',
        country: 'מדינה',
        application_date: 'תאריך בקשה',
        approver: 'מאשר',
        withdraw_approval: 'ביטול האישור',
        national_holiday_application: 'בקשה לחג לאומי',
        submit_for_approval: 'הגש לאישור',
        holiday_date: 'תאריך החג',
        holiday_description: 'תיאור החג',
    },
};
